// As a general rule you will start everything out by looking at the const for mutation-types.js
// Here's a quick why
// https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types

import { getters } from './getters';
import { actions } from './actions'
import mutations from './mutations'

const state = {
  startSchedule: false,
  selectedServices: [],
  vehicle: [],
  selectedDate: {},
  selectedTimeSlot: {},
  customerInfo: {},
  scheduleError: {},
  step: [],
  selectedOptionalServices: [],
  includedServices: [],
  tireQuotePriceDetails: {},
  chargesBreakdown: [],
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}